const USER_ID_KEY = "__current_user_id__";

function getCurrentUserId() {
  return localStorage.getItem(USER_ID_KEY) || "__default__";
}

export function setCurrentUserId(userId) {
  localStorage.setItem(USER_ID_KEY, userId || "__default__");
}

export function clearCurrentUserId() {
  localStorage.removeItem(USER_ID_KEY);
}

export function getScopedKey(key) {
  return `${key}_${getCurrentUserId()}`;
}

const userStorage = {
  getItem(key) {
    return localStorage.getItem(getScopedKey(key));
  },

  setItem(key, value) {
    localStorage.setItem(getScopedKey(key), value);
  },

  removeItem(key) {
    localStorage.removeItem(getScopedKey(key));
  },
};

export default userStorage;
